export default __webpack_public_path__ + "static/media/clipboard.80494daa.svg";